import React, { useEffect, useRef, useState } from "react";

import { BACKEND_URL } from "./backendconfig";
import Slider from "react-slick";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { formatPrice } from "./CourseData";
import { usePublicList } from "./usePublicList";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import "./FreeDemo.css";
function getBackendImageUrl(path) {
  if (typeof path !== "string" || !path.trim()) return "";

  try {
    const url = new URL(path.trim(), `${BACKEND_URL}/`);

    return ["http:", "https:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
}
// Replace these local image paths, video URLs and purchase links with your own.
const COURSE_URL = "https://www.embroiderydesigncourse.com/courses/";
const CONTACT = {
  name: "LifeTime Embroidery Design Class",
  phone: "9879196990",
  secondPhone: "9909614445",
  website: "https://www.embroiderydesigncourse.com",
  address:
    "Shop-17, UP GR Floor, Ranuja Complex, Nr- Riddhi Siddhi School, Vallabhacharya Road, Ashvani Kumar,Surat-395008 Gujarat, India",
  hours: "Call or WhatsApp us for class timings",
};
const categories = [
  { id: "freedemo", label: "Free Demo" },
  { id: "all", label: "All Courses" },
  { id: "multi", label: "Multi Design" },
  // { id: "sequin", label: "Sequin" },
  // { id: "cording", label: "Cording" },
  // { id: "chain", label: "Chain" },

  // { id: "beads", label: "Beads" },
];

const faqs = [
  [
    "Can I join if I am a beginner?",
    "Yes. You can start with basic tools and simple designs. Contact us to find a course that matches your experience.",
  ],
  [
    "What types of embroidery can I learn?",
    "You can explore Multi Design, Cording, Chain, Sequin and Beads. Check the course details to see what each course covers.",
  ],
  [
    "How do I book a free demo class?",
    "Click Get Free Demo Course to open the Free Demo page and watch our available topics.",
  ],
  [
    "Which software do I need?",
    "The software depends on your course. Contact us before joining to confirm the software version and computer requirements.",
  ],
  [
    "Where can I check the fees and course length?",
    "Open the course details to read about the topics and fees.",
  ],
  [
    "Can these skills help me work or start a business?",
    "Embroidery design skills can help you prepare for design work or explore your own business. Your progress will depend on your practice, experience and the opportunities available to you.",
  ],
  [
    "How do I join a course?",
    "Click Buy Now to visit our courses website. You can also call or WhatsApp us if you need help choosing a course.",
  ],
];
const whatsapp = (message) =>
  `https://wa.me/91${CONTACT.phone}?text=${encodeURIComponent(message)}`;

export function Picture({ src, alt, className = "", ...props }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return failed ? (
    <div
      className={`el-image-placeholder ${className}`}
      role="img"
      aria-label={alt}
    >
      <span>✿</span>
      <small>{alt}</small>
    </div>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...props}
    />
  );
}
function getYouTubeThumbnail(link) {
  try {
    const url = new URL(link);
    const host = url.hostname.replace(/^www\./, "");
    let videoId = "";

    if (host === "youtu.be") {
      videoId = url.pathname.split("/")[1];
    } else if (
      host === "youtube.com" ||
      host === "m.youtube.com" ||
      host === "youtube-nocookie.com"
    ) {
      const parts = url.pathname.split("/").filter(Boolean);

      videoId =
        url.searchParams.get("v") ||
        (["shorts", "embed", "live"].includes(parts[0]) ? parts[1] : "");
    }

    return /^[A-Za-z0-9_-]{11}$/.test(videoId || "")
      ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`
      : "/images/embroidery/video-placeholder.webp";
  } catch {
    return "/images/embroidery/video-placeholder.webp";
  }
}
function CourseRow({ title, subtitle, items, onDetails, demo }) {
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState(null);

  const closeImage = React.useCallback(() => {
    setPreviewImage(null);
  }, []);
  useEffect(() => {
    const title = "Online & Offline Embroidery Design Courses | LifeTime";

    const description =
      "Learn computer embroidery design with LifeTime through online classes, offline training and video lessons. Explore Multi, Cording, Sequin, Chain and Beads.";
    const pageUrl = "https://www.embroiderydesigncourse.com/";
    const imageUrl = new URL("/logo.jpg", pageUrl).href;

    const previousTitle = document.title;
    const restoreTags = [];

    const setMeta = (attribute, name, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${name}"]`);

      const existed = Boolean(element);
      const previousContent = element?.getAttribute("content");

      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute("content", content);

      restoreTags.push(() => {
        if (!existed) {
          element.remove();
        } else if (previousContent === null) {
          element.removeAttribute("content");
        } else {
          element.setAttribute("content", previousContent);
        }
      });
    };

    document.title = title;

    setMeta("name", "description", description);
    setMeta("name", "robots", "index, follow, max-image-preview:large");

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", CONTACT.name);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", pageUrl);
    setMeta("property", "og:image", imageUrl);
    setMeta("property", "og:image:alt", CONTACT.name);

    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", imageUrl);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    const canonicalExisted = Boolean(canonical);
    const previousCanonical = canonical?.getAttribute("href");

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href = pageUrl;

    const structuredData = document.createElement("script");
    structuredData.type = "application/ld+json";

    structuredData.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "@id": `${pageUrl}#organization`,
      name: CONTACT.name,
      url: pageUrl,
      logo: imageUrl,
      description,
      telephone: `+91${CONTACT.phone}`,
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "Shop-17, UP GR Floor, Ranuja Complex, Near Riddhi Siddhi School, Vallabhacharya Road, Ashvani Kumar",
        addressLocality: "Surat",
        addressRegion: "Gujarat",
        postalCode: "395008",
        addressCountry: "IN",
      },
    });

    document.head.appendChild(structuredData);

    return () => {
      document.title = previousTitle;
      restoreTags.reverse().forEach((restore) => restore());
      structuredData.remove();

      if (!canonicalExisted) {
        canonical.remove();
      } else if (previousCanonical === null) {
        canonical.removeAttribute("href");
      } else {
        canonical.setAttribute("href", previousCanonical);
      }
    };
  }, []);

  return (
    <div className="el-course-row">
      <div className="el-row-heading">
        <div>
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </div>
      </div>

      {items.length > 0 ? (
        <CardCarousel label={title}>
          {items.map((course) => (
            <article
              key={course.id}
              className="el-course-card"
              onClick={(event) => {
                // Let buttons and links perform their own actions.
                if (event.target.closest("a, button")) return;

                navigate(
                  demo
                    ? "/free-demo"
                    : `/courses/${encodeURIComponent(course.id)}`,
                );
              }}
            >
              <div className="el-card-image">
                <button
                  type="button"
                  className="ltc-course-image-button"
                  aria-label={`View ${course.title} image`}
                  aria-haspopup="dialog"
                  onClick={(event) => {
                    event.stopPropagation();

                    setPreviewImage({
                      src: getBackendImageUrl(course.image),
                      title: course.title,
                    });
                  }}
                >
                  <Picture
                    src={getBackendImageUrl(course.image)}
                    alt={course.title}
                    loading="lazy"
                  />
                </button>

                {/* <span className={`el-badge ${demo ? "el-demo" : ""}`}>
                  {demo ? "FREE DEMO" : "COMPLETE COURSE"}
                </span> */}
              </div>

              <div className="el-card-body">
                <span className="el-course-category">
                  {
                    categories.find((item) => item.id === course.category)
                      ?.label
                  }
                </span>

                <h4>{course.title}</h4>

                <p className="el-description-clamp">{course.description}</p>

                <button
                  type="button"
                  className="el-read-more"
                  onClick={() => onDetails(course)}
                >
                  Read More
                </button>

                <div className="el-course-meta">
                  <span>{course.duration}</span>
                  <strong>{formatPrice(course.price)}</strong>
                </div>
                <div className="el-card-actions">
                  <Link
                    className="el-button el-button-outline"
                    to={
                      demo
                        ? "/free-demo"
                        : `/courses/${encodeURIComponent(course.id)}`
                    }
                  >
                    View Topics
                  </Link>

                  {demo ? (
                    <Link className="el-button" to="/free-demo">
                      Get Free Demo Course
                    </Link>
                  ) : (
                    <a
                      className="el-button"
                      href={`${COURSE_URL}${encodeURIComponent(course.id)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Buy Now
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </CardCarousel>
      ) : (
        <p>No courses available in this category.</p>
      )}
      {previewImage && (
        <Modal title={previewImage.title} onClose={closeImage}>
          <div className="ltc-course-image-preview">
            <Picture
              src={previewImage.src}
              alt={previewImage.title}
              className="ltc-course-preview-image"
            />

            <p>{previewImage.title}</p>
          </div>
        </Modal>
      )}
    </div>
  );
}
function CardCarousel({ children, label }) {
  const rowRef = useRef(null);

  const moveCards = (direction) => {
    const row = rowRef.current;
    if (!row) return;

    const card = row.firstElementChild;
    const gap = parseFloat(window.getComputedStyle(row).columnGap) || 0;
    const distance = card
      ? card.getBoundingClientRect().width + gap
      : row.clientWidth;

    row.scrollBy({
      left: direction * distance,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
    });
  };

  return (
    <div className="el-card-carousel">
      <button
        type="button"
        className="el-carousel-arrow"
        aria-label={`Previous ${label}`}
        onClick={() => moveCards(-1)}
      >
        ←
      </button>

      <div
        ref={rowRef}
        className="el-carousel-track"
        role="region"
        aria-label={label}
        tabIndex={0}
      >
        {children}
      </div>

      <button
        type="button"
        className="el-carousel-arrow"
        aria-label={`Next ${label}`}
        onClick={() => moveCards(1)}
      >
        →
      </button>
    </div>
  );
}
export function Modal({
  children,
  onClose,
  title,
  classPrefix = "ltc-dialog",
}) {
  const box = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    box.current?.focus();
    const keydown = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "Tab") {
        const nodes = box.current?.querySelectorAll(
          'a[href],button:not([disabled]),[tabindex="0"]',
        );
        if (!nodes?.length) return;
        const first = nodes[0],
          last = nodes[nodes.length - 1];
        if (
          event.shiftKey &&
          (document.activeElement === first ||
            document.activeElement === box.current)
        ) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", keydown);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener("keydown", keydown);
      previous?.focus();
    };
  }, [onClose]);
  return (
    <div className={`${classPrefix}-overlay`} onClick={onClose}>
      <div
        ref={box}
        className={`${classPrefix}-box`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className={`${classPrefix}-close`}
          aria-label="Close dialog"
          onClick={onClose}
        >
          ×
        </button>

        <div className={`${classPrefix}-content`}>{children}</div>
      </div>
    </div>
  );
}
export default function Home() {
  const {
    items: courses,
    loading: coursesLoading,
    error: coursesError,
  } = usePublicList(`${BACKEND_URL}/courses.php`);

  const {
    items: videos,
    loading: videosLoading,
    error: videosError,
  } = usePublicList(`${BACKEND_URL}/media.php?type=youtube`);

  const {
    items: gallery,
    loading: galleryLoading,
    error: galleryError,
  } = usePublicList(`${BACKEND_URL}/media.php?type=gallery`);

  const {
    items: banners,
    loading: bannersLoading,
    error: bannersError,
  } = usePublicList(`${BACKEND_URL}/media.php?type=banner`);
  const {
    items: aboutImages,
    loading: aboutLoading,
    error: aboutError,
  } = usePublicList(`${BACKEND_URL}/media.php?type=about`);

  const aboutImage = aboutImages[0];

  const {
    items: designers,
    loading: designersLoading,
    error: designersError,
  } = usePublicList(`${BACKEND_URL.replace(/\/+$/, "")}/designers.php`);

  const { hash, key } = useLocation();

  const pageLoading =
    coursesLoading ||
    videosLoading ||
    galleryLoading ||
    bannersLoading ||
    designersLoading ||
    aboutLoading;

  useEffect(() => {
    if (!hash || pageLoading) return;

    let sectionId;

    try {
      sectionId = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }

    let firstFrame;
    let secondFrame;
    let correctionTimer;

    const scrollToTarget = () => {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };

    // Wait for React's updated layout to reach the screen.
    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(scrollToTarget);
    });

    // Correct the position when images above the section finish loading.
    const handleImageLoad = (event) => {
      if (!(event.target instanceof HTMLImageElement)) return;

      window.clearTimeout(correctionTimer);
      correctionTimer = window.setTimeout(scrollToTarget, 100);
    };

    const stopTracking = () => {
      document.removeEventListener("load", handleImageLoad, true);
      window.clearTimeout(correctionTimer);
    };

    document.addEventListener("load", handleImageLoad, true);

    // Stop adjusting once the visitor interacts with the page.
    window.addEventListener("wheel", stopTracking, { passive: true });
    window.addEventListener("touchstart", stopTracking, { passive: true });
    window.addEventListener("pointerdown", stopTracking);
    window.addEventListener("keydown", stopTracking);

    const trackingTimer = window.setTimeout(stopTracking, 5000);

    return () => {
      stopTracking();
      window.cancelAnimationFrame(firstFrame);
      window.cancelAnimationFrame(secondFrame);
      window.clearTimeout(trackingTimer);

      window.removeEventListener("wheel", stopTracking);
      window.removeEventListener("touchstart", stopTracking);
      window.removeEventListener("pointerdown", stopTracking);
      window.removeEventListener("keydown", stopTracking);
    };
  }, [hash, key, pageLoading]);

  const [category, setCategory] = useState("all");
  const [selected, setSelected] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(null);

  const photo = photoIndex === null ? null : gallery[photoIndex];

  const closeGallery = React.useCallback(() => {
    setPhotoIndex(null);
  }, []);

  const movePhoto = React.useCallback(
    (direction) => {
      if (!gallery.length) return;

      setPhotoIndex((current) =>
        current === null
          ? null
          : (current + direction + gallery.length) % gallery.length,
      );
    },
    [gallery.length],
  );

  useEffect(() => {
    if (photoIndex === null) return;

    const handleGalleryKeys = (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        movePhoto(-1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        movePhoto(1);
      }
    };

    document.addEventListener("keydown", handleGalleryKeys);

    return () => {
      document.removeEventListener("keydown", handleGalleryKeys);
    };
  }, [photoIndex, movePhoto]);
  const filtered = courses.filter(
    (course) => category === "all" || course.category === category,
  );
  return (
    <main className="embroidery-landing">
      <section className="el-hero" aria-label="Embroidery course introduction">
        <div className="el-container el-hero-grid">
          <div className="el-hero-content">
            <span className="el-eyebrow">LifeTime Embroidery Design Class</span>

            <h2>Embroidery Design Training</h2>

            <p>
              At LifeTime Embroidery Design Class, we help beginners and
              experienced learners develop computer embroidery design skills
              through online classes, offline classroom training and video
              lessons.
            </p>

            <ul className="el-check-list">
              <li>Online classes to learn remotely</li>
              <li>Offline practical training at our Surat classroom</li>
              <li>Step-by-step embroidery design video lessons</li>
              <li>Practice with real embroidery designs</li>
            </ul>

            <div className="el-hero-actions">
              <a href="#courses" className="el-button">
                Explore Courses ↗
              </a>

              <Link to="/free-demo" className="el-button el-button-outline">
                Get Free Demo Course ↗
              </Link>
            </div>
          </div>

          <div className="el-hero-visual">
            {bannersLoading && <p role="status">Loading banners…</p>}

            {bannersError && <p role="alert">{bannersError}</p>}

            {!bannersLoading && !bannersError && banners.length === 0 && (
              <p>No banner images available.</p>
            )}

            {!bannersLoading && !bannersError && banners.length > 0 && (
              <Slider
                key={banners.map((image) => image.id).join("-")}
                arrows={false}
                dots={banners.length > 1}
                infinite={banners.length > 1}
                autoplay={banners.length > 1}
                autoplaySpeed={3000}
                speed={700}
                slidesToShow={1}
                slidesToScroll={1}
                fade
                pauseOnHover
                pauseOnFocus
                adaptiveHeight
              >
                {banners.map((image, index) => (
                  <div key={image.id}>
                    <Picture
                      src={image.src}
                      alt={image.alt || "Embroidery design training"}
                      className="el-hero-photo"
                      loading={index === 0 ? "eager" : "lazy"}
                      fetchPriority={index === 0 ? "high" : "auto"}
                    />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </section>
      {/* <section className="el-stats" aria-label="Training statistics">
        <div className="el-container el-stats-grid">
          {[
            ["0+", "Students Trained"],
            ["0+", "Successful Students"],
            ["100%", "Practical Training"],
            ["Free Demo", "Try Before You Join"],
          ].map(([value, label]) => (
            <div key={label}>
              <strong>{value}</strong>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </section> */}
      <section id="about" className="el-section">
        <div className="el-container el-about-grid">
          <div className="ltc-about-media">
            {aboutLoading && <p role="status">Loading image…</p>}

            {aboutError && <p role="alert">{aboutError}</p>}

            {!aboutLoading && !aboutError && aboutImage && (
              <Picture
                src={getBackendImageUrl(aboutImage.src)}
                alt={aboutImage.alt || "LifeTime embroidery design training"}
                className="el-about-image"
                loading="lazy"
                decoding="async"
              />
            )}

            {!aboutLoading && !aboutError && !aboutImage && (
              <p>No About image available.</p>
            )}
          </div>
          <div>
            <span className="el-eyebrow">ABOUT OUR TRAINING</span>
            <h2>20 Year Designing Experience</h2>
            <h4 style={{ margin: "20px auto", color: "#176b4d" }}>
              Learn new skills, Create your own designs.
            </h4>
            <p>
              At LifeTime Embroidery Design Class, we teach you how to turn a
              picture or drawing into an embroidery design. Follow each topic,
              practise on your computer, and learn how to prepare a design for
              an embroidery machine.
            </p>
            <p>
              Learn to make small designs and borders, choose stitches, arrange
              colors, and check your work. Explore Multi Design, Cording, Chain
              Stitch, Sequin and Beads courses.
            </p>
            <ul className="el-check-list">
              <li>Simple topics explained step by step</li>
              <li>Practice with real embroidery designs</li>
              <li>Learn to check designs before machine stitching</li>
            </ul>
            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
              <a
                href="https://www.embroiderydesigncourse.com/contact-us"
                className="el-button"
              >
                Contact Now ↗
              </a>

              <Link to="/free-demo" className="el-button">
                Get Free Demo Course ↗
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section id="courses" className="el-section el-soft">
        <div className="el-container">
          <div className="el-section-heading">
            <span className="el-eyebrow">CHOOSE YOUR COURSE</span>
            <h2>Embroidery Design Courses</h2>
            <p>
              Choose the type of embroidery you want to learn. Book a free demo
              or view the topics in a complete course.
            </p>
          </div>
          <div className="el-tabs" aria-label="Filter courses by category">
            {categories.map((item) =>
              item.id === "freedemo" ? (
                <Link key={item.id} to="/free-demo" className="el-demo-tab">
                  Free Demo ↗
                </Link>
              ) : (
                <button
                  type="button"
                  key={item.id}
                  className={category === item.id ? "active" : ""}
                  aria-pressed={category === item.id}
                  onClick={() => setCategory(item.id)}
                >
                  {item.label}
                </button>
              ),
            )}
          </div>

          {coursesLoading && <p role="status">Loading courses…</p>}
          {coursesError && <p role="alert">{coursesError}</p>}
          {!coursesLoading && !coursesError && (
            <CourseRow
              title=""
              subtitle=""
              items={filtered.filter((x) => x.type !== "demo")}
              onDetails={setSelected}
            />
          )}
        </div>
      </section>
      <section id="videos" className="el-section">
        <div className="el-container">
          <div className="el-section-heading">
            <span className="el-eyebrow">WATCH & LEARN</span>
            <h2>Our YouTube Videos</h2>
            <p>
              Watch simple embroidery design topics and see how designs are
              made.
            </p>
          </div>
          {videosLoading && <p role="status">Loading videos…</p>}
          {videosError && <p role="alert">{videosError}</p>}
          {!videosLoading && !videosError && videos.length === 0 && (
            <p>No YouTube videos added yet.</p>
          )}
          <CardCarousel label="YouTube videos">
            {videos.map((video, index) => (
              <article
                className="el-video-card"
                key={`${video.url || video.title}-${index}`}
              >
                {video.url ? (
                  <a
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="el-video-cover"
                    aria-label={`Watch ${video.title} on YouTube`}
                  >
                    <Picture
                      src={getYouTubeThumbnail(video.url)}
                      alt={video.title}
                      loading="lazy"
                    />
                    <span className="el-play">▶</span>
                  </a>
                ) : (
                  <div className="el-video-cover">
                    <Picture
                      src={getYouTubeThumbnail(video.url)}
                      alt={video.title}
                      loading="lazy"
                    />
                  </div>
                )}
                <div>
                  <h3>{video.title}</h3>
                  {video.url ? (
                    <a
                      href={video.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Watch on YouTube ↗
                    </a>
                  ) : (
                    <span className="el-muted">Video link coming soon</span>
                  )}
                </div>
              </article>
            ))}
          </CardCarousel>
        </div>
      </section>
      <section id="why-us" className="el-section el-dark">
        <div className="el-container">
          <div className="el-section-heading">
            <span className="el-eyebrow">WHY CHOOSE US</span>
            <h2>Learn by watching and practising.</h2>
            <p>
              Understand each step, from choosing a picture to preparing the
              finished embroidery design.
            </p>
          </div>
          <div className="el-feature-grid">
            {[
              [
                "01",
                "Focussed On Learning",
                "We are Focusing on every Student To Learning  Embroidery Design Course Step By Step and give essential content to every student  .",
              ],
              [
                "02",
                "Basic Course  To Master Course Design",
                "We Design Embroidery Course From Basic To Mater Course, So Every Student Develop Essential  Skill in Embroidery Fild and get Highest Salary Packages.",
              ],
              [
                "03",
                "100% Job Support",
                "If You are Learn very well and complete our courses,  We give Job support  to them.",
              ],
              [
                "04",
                "Learnig Methods",
                "We are learning our students by Projectors, Videos, and Personal Guides.We also cover to make design by Sample Prectichs",
              ],
              [
                "05",
                "Course Periods (4-5 Months)",
                "We design Of-line  course 4-5 months in our class. We cover Malti , Coding, Chain, Sequien, Double Sequien, Beads.",
              ],
            ].map(([n, title, text]) => (
              <article key={n}>
                <span>{n}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section id="gallery" className="el-section">
        <div className="el-container">
          <div className="el-section-heading">
            <span className="el-eyebrow">OUR CLASS & DESIGN WORK</span>

            <h2>Class & Design Gallery</h2>

            <p>
              See photos from our class and examples of embroidery design work.
            </p>
          </div>

          {galleryLoading && <p role="status">Loading gallery…</p>}

          {galleryError && <p role="alert">{galleryError}</p>}

          {!galleryLoading && !galleryError && gallery.length === 0 && (
            <p>No gallery images added yet.</p>
          )}

          {!galleryLoading && !galleryError && gallery.length > 0 && (
            <div className="ltc-gallery-carousel">
              <CardCarousel label="gallery images">
                {gallery.map((item, index) => (
                  <button
                    key={item.src}
                    type="button"
                    className="ltc-gallery-card"
                    onClick={() => setPhotoIndex(index)}
                    aria-label={`View ${item.alt || item.title || "gallery image"}`}
                    aria-haspopup="dialog"
                  >
                    <Picture
                      src={item.src}
                      alt={item.alt || item.title || "Gallery image"}
                      loading="lazy"
                    />

                    <span className="ltc-gallery-caption">View Image ↗</span>
                  </button>
                ))}
              </CardCarousel>
            </div>
          )}
        </div>
      </section>
      <section className="el-section ltc-designers-section" id="designers">
        <div className="el-container">
          <div className="el-section-heading">
            <span className="el-eyebrow">OUR DESIGNERS SALARY PACKAGE</span>

            <h2>We are Proud of Our Designers</h2>

            <p>Meet our designers and explore their professional journeys.</p>
          </div>
          {designersLoading && <p role="status">Loading designers…</p>}

          {designersError && <p role="alert">{designersError}</p>}

          {!designersLoading && !designersError && designers.length === 0 && (
            <p>No designer details available yet.</p>
          )}
          <div className="ltc-designers-grid">
            {designers.map((designer) => (
              <article className="ltc-designer-card" key={designer.id}>
                <div className="ltc-designer-photo">
                  <Picture
                    src={
                      designer.image
                        ? new URL(
                            designer.image,
                            `${BACKEND_URL.replace(/\/+$/, "")}/`,
                          ).href
                        : ""
                    }
                    alt={designer.name}
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="ltc-designer-experience">
                    {designer.experience} Experience
                  </span>
                </div>

                <div className="ltc-designer-content">
                  <h3>{designer.name}</h3>

                  <p className="ltc-designer-designation">
                    {designer.designation}
                  </p>

                  <div className="ltc-designer-salary">
                    <span>Salary Package</span>

                    <div>
                      <strong>{designer.salary}</strong>
                      <small>{designer.salaryPeriod}</small>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section id="book-demo" className="el-career-section">
        <div className="el-container">
          <div className="el-career-card">
            <div className="el-career-art" aria-hidden="true">
              <span>✿</span>
              <i></i>
              <b>
                MAKE YOUR
                <br />
                NEXT STITCH
                <br />A BIG STEP.
              </b>
            </div>
            <div className="el-career-copy">
              <span className="el-eyebrow">TAKE YOUR FIRST STEP</span>
              <h2>YOUR EMBROIDERY DESIGN CAREER STARTS HERE.</h2>
              <p>
                GET free demo course and discover how professional embroidery
                designing can help you build a career or start your own
                business.
              </p>
              <div className="el-career-actions">
                <Link to="/free-demo" className="el-button el-button-gold">
                  GET FREE DEMO COURSE ↗
                </Link>
                <a
                  href={whatsapp(
                    "Hello, I would like to know more about your embroidery design course.",
                  )}
                  className="el-button el-button-whatsapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CHAT ON WHATSAPP ↗
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="el-section el-soft">
        <div className="el-container el-faq-layout">
          <div className="HEAD">
            <span className="el-eyebrow">YOUR QUESTIONS, ANSWERED</span>
            <h2>Frequently Asked Questions</h2>
            <p>
              Not sure which course to choose? Contact us for help with courses,
              fees and class timings.
            </p>
            <a className="el-button" href="#contact">
              Contact Us ↗
            </a>
          </div>
          <div className="el-faq-list">
            {faqs.map(([question, answer]) => (
              <details key={question}>
                <summary>
                  {question}
                  <span aria-hidden="true">+</span>
                </summary>
                <p>{answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="el-section">
        <div className="el-container el-contact">
          <div>
            <span className="el-eyebrow">CONTACT OUR CLASS</span>
            <h2>Ready to learn embroidery design?</h2>
            <p>
              Call or message LifeTime Embroidery Design Class to ask about
              course fees, free demo classes and available batches.
            </p>
            <a
              href={whatsapp(
                "Hello, please share details about your embroidery design courses.",
              )}
              className="el-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chat on WhatsApp ↗
            </a>
          </div>
          <div className="el-contact-info">
            <h3>{CONTACT.name}</h3>
            <div>
              <span>Call Us</span>
              <a href={`tel:+91${CONTACT.phone}`}>+91 {CONTACT.phone}</a>
              <a href={`tel:+91${CONTACT.secondPhone}`}>
                +91 {CONTACT.secondPhone}
              </a>
            </div>
            <div>
              <span>Visit Us</span>
              <p>{CONTACT.address}</p>
            </div>
            <div>
              <span>Batch Timings</span>
              <p>{CONTACT.hours}</p>
            </div>
            <div>
              <span>Website</span>
              <a
                href={CONTACT.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                embroiderydesigncourse.com ↗
              </a>
            </div>
          </div>
        </div>
      </section>
      {selected && (
        <Modal title={selected.title} onClose={() => setSelected(null)}>
          <div className="ltc-course-info">
            <header className="ltc-course-info-header">
              <span className="ltc-course-info-badge">
                {selected.type === "demo" ? "FREE DEMO" : "COURSE DETAILS"}
              </span>

              <h2 className="ltc-course-info-title">{selected.title}</h2>

              <p className="ltc-course-info-description">
                {selected.description}
              </p>
            </header>

            {selected.topics?.length > 0 && (
              <section className="ltc-course-info-topics">
                <h3>What You Will Learn</h3>

                <ul>
                  {selected.topics.map((topic, index) => (
                    <li key={`${index}-${topic}`}>
                      <span aria-hidden="true">✓</span>
                      <span>{topic}</span>
                    </li>
                  ))}
                </ul>
              </section>
            )}

            <div className="ltc-course-info-meta">
              <div className="ltc-course-info-stat">
                <span>Course Fees</span>
                <strong>{formatPrice(selected.price)}</strong>
              </div>

              <div className="ltc-course-info-stat">
                <span>Course Duration</span>
                <strong>
                  {selected.duration || "Contact us for duration"}
                </strong>
              </div>
            </div>

            <footer className="ltc-course-info-footer">
              <p>Start your embroidery design journey.</p>

              {selected.type === "demo" ? (
                <Link
                  to="/free-demo"
                  className="ltc-course-info-cta"
                  onClick={() => setSelected(null)}
                >
                  Get Free Demo Course <span aria-hidden="true">↗</span>
                </Link>
              ) : (
                <a
                  href={`${COURSE_URL}${encodeURIComponent(selected.id)}`}
                  className="ltc-course-info-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Buy Now <span aria-hidden="true">↗</span>
                </a>
              )}
            </footer>
          </div>
        </Modal>
      )}
      {photo && (
        <Modal
          title={photo.alt || photo.title || "Gallery image"}
          onClose={closeGallery}
          classPrefix="ltc-gallery-viewer"
        >
          <div className="ltc-gallery-viewer-stage">
            <Picture
              src={photo.src}
              alt={photo.alt || photo.title || "Gallery image"}
              className="ltc-gallery-viewer-image"
            />
          </div>

          <div className="ltc-gallery-viewer-footer">
            <button
              type="button"
              className="ltc-gallery-viewer-arrow"
              aria-label="Previous image"
              onClick={() => movePhoto(-1)}
              disabled={gallery.length < 2}
            >
              ←
            </button>

            <div
              className="ltc-gallery-viewer-info"
              aria-live="polite"
              aria-atomic="true"
            >
              {/* <p>{photo.alt || photo.title || "Gallery image"}</p> */}
              <span>
                {photoIndex + 1} / {gallery.length}
              </span>
            </div>

            <button
              type="button"
              className="ltc-gallery-viewer-arrow"
              aria-label="Next image"
              onClick={() => movePhoto(1)}
              disabled={gallery.length < 2}
            >
              →
            </button>
          </div>
        </Modal>
      )}
    </main>
  );
}
